import copyToClipboard from 'copy-to-clipboard'
import { usePersistFn } from 'ahooks'
import $msg from '../message'

const useCopy = () => {
    const copy = usePersistFn((text: string) => {
        copyToClipboard(text)
        $msg('success', '复制成功')
    })

    return copy
}

export default useCopy
